import { Typography, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import AppTextInput from "../../app/components/AppTextInput";

export default function ProfileForm() {
  
  const {control} = useFormContext()
  return (
    <>
        
        <Grid container spacing={3}>
                  <Grid item xs={12} sm={12}>
                    <AppTextInput control={control} name='fullName' label='Full name'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <AppTextInput control={control} name='address1' label='Address 1'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <AppTextInput control={control} name='address2' label='Address 2'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='city' label='City'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='region' label='Region'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='postCode' label='postal Code'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='country' label='Country'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <AppTextInput control={control} name='phoneNumber' label='Phone number'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                  
            
            
       
                  </Grid>
                
            </Grid>
      </>
  )
}